import React from "react";
import { Link } from "react-router-dom";

function TextLink(props) {
  return (
    <Link to={props.url} target="_blank" rel="noreferrer">
      {props.text}
    </Link>
  );
}

export default TextLink;